import { useState, useEffect, useCallback } from "react";
import employeeService from "Services/AdminServices/EmployeeService";
import { message } from "antd";
import moment from "moment";
import {
  DesignationLevelEnum,
} from "Constants/Enums/DesignationLevelEnum";

function jobInviteService() {
  const [jobFormData, setJobFormData] = useState({
    hiringDate: "",
    probationStartDate: "",
    probationEndDate: "",
    payType: 0,
    baseSalary: "",
    priorExperience:"",
    designationId: 0,
    designationLevel: DesignationLevelEnum.Executive,
    departmentId: 0,
    jobTitleId: 0,
  });

  const [jobFormDataError, setJobFormDataError] = useState({
    hiringDateError: "",
    probationStartDateError: "",
    probationEndDateError: "",
    payTypeError: "",
    designationIdError: "",
    designationLevelError: "",
    baseSalaryError: "",
    priorExperienceError:"",
    departmentIdError: "",
    jobTitleIdError: "",
  });

  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);


useEffect(() => {
  const fetchDesignations = async () => {
    try {
      
      if (
        jobFormData.designationLevel === undefined ||
        jobFormData.designationLevel === null
      ) return;

      const level = Number(jobFormData.designationLevel);

      if (level < 0) return;

      const res = await employeeService.getDesignationsByLevels([level]);

      setDesignations(res || []);
    } catch (err) {
      console.error("Error fetching designations", err);
    }
  };

  fetchDesignations();
}, [jobFormData.designationLevel]);

  // Fetch departments
  useEffect(() => {
    async function fetchDepartments() {
      try {
        const res = await employeeService.getDepartments();
        setDepartments(res || []);
      } catch (err) {
        console.error("Error fetching departments", err);
      }
    }
    fetchDepartments();
  }, []);

  // Fetch job titles when department changes
  useEffect(() => {
    async function fetchJobTitles() {
      if (!jobFormData.departmentId) {
        setJobTitles([]);
        return;
      }
      try {
        const res = await employeeService.getJobTitles(jobFormData.departmentId);
        setJobTitles(res || []);
      } catch (err) {
        console.error("Error fetching job titles", err);
      }
    }
    fetchJobTitles();
  }, [jobFormData.departmentId]);

  // Date restriction functions
  const disableProbationStart = (current) => {
  if (!jobFormData.hiringDate) return false;

  const hiring = moment(jobFormData.hiringDate, "YYYY-MM-DD").startOf("day");

  //  disable only before hiring date
  return current && current.isBefore(hiring, "day");
};

  const disableProbationEnd = (current) => {
    if (!jobFormData.probationStartDate) return false;
    return current && current <= moment(jobFormData.probationStartDate, "YYYY-MM-DD").startOf("day");
  };

  // Validate date fields
  const validateDateFields = useCallback((updatedData) => {
    const { hiringDate, probationStartDate, probationEndDate } = updatedData;
    let errors = {
      hiringDateError: "",
      probationStartDateError: "",
      probationEndDateError: "",
    };

    // 1. Hiring Date vs Probation Start
    if (hiringDate && probationStartDate) {
      if (new Date(probationStartDate) < new Date(hiringDate)) {
        errors.probationStartDateError = "Probation start cannot be before hiring date";
      }
    }

    // 2. Probation Start vs Probation End
    if (probationStartDate && probationEndDate) {
      if (new Date(probationEndDate) <= new Date(probationStartDate)) {
        errors.probationEndDateError = "Probation end must be after probation start";
      }
    }

    return errors;
  }, []);

  // Handle form field changes
  const handleJobChange = useCallback((e) => {
    const { name, value } = e.target;
    let newValue = value;

    // Convert numeric fields
    if (["designationId","priorExperience", "baseSalary", "payType", "departmentId", "jobTitleId", "designationLevel"].includes(name)) {
      newValue = Number(value) || 0;
    }

    // Update State
    setJobFormData((prev) => {
      const updatedState = { ...prev, [name]: newValue };
      
      // Run cross-validation on the NEW state immediately
      const dateErrors = validateDateFields(updatedState);
      
      setJobFormDataError((prevErrors) => ({
        ...prevErrors,
        ...dateErrors,
        [`${name}Error`]: dateErrors[`${name}Error`] || ""
      }));

      return updatedState;
    });
  }, [validateDateFields]);

  // Handle designation level change separately
  const handleDesignationLevelChange = useCallback((value) => {
    const newValue = Number(value) || 0;
    
    setJobFormData((prev) => {
      const updatedState = { ...prev, designationLevel: newValue };
      
      // Clear department and job title when switching to executive
      if (newValue === DesignationLevelEnum.Executive) {
        updatedState.departmentId = 0;
        updatedState.jobTitleId = 0;
        
        // Clear errors for department and job title
        setJobFormDataError((prevErrors) => ({
          ...prevErrors,
          departmentIdError: "",
          jobTitleIdError: "",
        }));
      }
      
      return updatedState;
    });
  }, []);

  // Check if it's an executive role
  const isExecutive = useCallback(() => {
    return Number(jobFormData.designationLevel) === DesignationLevelEnum.Executive;
  }, [jobFormData.designationLevel]);

  // Validation function
const validateStep2 = useCallback(() => {
  let valid = true;
  const errors = {};

  console.log("=== VALIDATION START ===");
  console.log("Form Data:", jobFormData);
  console.log("Is Executive:", isExecutive());

  // Hiring Date
  if (!jobFormData.hiringDate) {
    errors.hiringDateError = "Hiring Date is required";
    valid = false;
  }

  // Probation Dates
  if (!jobFormData.probationStartDate) {
    errors.probationStartDateError = "Probation Start Date is required";
    valid = false;
  }

  if (!jobFormData.probationEndDate) {
    errors.probationEndDateError = "Probation End Date is required";
    valid = false;
  }

  // Pay Type
  if (jobFormData.payType === undefined || jobFormData.payType === null) {
    errors.payTypeError = "Pay Type is required";
    valid = false;
  }

  // ✅ FIXED: Designation Level (NO extra block)
  if (
    jobFormData.designationLevel === undefined ||
    jobFormData.designationLevel === null
  ) {
    errors.designationLevelError = "Designation Level is required";
    valid = false;
  }

  // Designation
  if (!jobFormData.designationId || jobFormData.designationId === 0) {
    errors.designationIdError = "Designation is required";
    valid = false;
  }

  // Prior Expereince 
  if (!jobFormData.priorExperience || parseFloat(jobFormData.priorExperience) <0) {
    errors.priorExperienceError = "A valid Prior Experience is required";
    valid = false;
  }

  // Base Salary
  if (!jobFormData.baseSalary || parseFloat(jobFormData.baseSalary) <= 0) {
    errors.baseSalaryError = "A valid Base Salary is required";
    valid = false;
  }

  // Executive check
  const isExec = isExecutive();
  console.log("Is Executive:", isExec, "Designation Level:", jobFormData.designationLevel);

  // Department + Job Title (ONLY if NOT executive)
  if (!isExec) {
    if (!jobFormData.departmentId || jobFormData.departmentId === 0) {
      errors.departmentIdError = "Department is required";
      valid = false;
    }

    if (!jobFormData.jobTitleId || jobFormData.jobTitleId === 0) {
      errors.jobTitleIdError = "Job Title is required";
      valid = false;
    }
  }

  setJobFormDataError(errors);
  console.log("Validation errors:", errors);
  console.log("=== VALIDATION END ===");

  return valid;
}, [jobFormData, isExecutive]);

  // Function to reset form data
  const resetFormData = useCallback(() => {
    setJobFormData({
      hiringDate: "",
      probationStartDate: "",
      probationEndDate: "",
      payType: 0,
      priorExperience:"",
      baseSalary: "",
      designationId: 0,
      designationLevel: DesignationLevelEnum.Executive,
      departmentId: 0,
      jobTitleId: 0,
    });
    setJobFormDataError({
      hiringDateError: "",
      probationStartDateError: "",
      probationEndDateError: "",
      payTypeError: "",
      designationIdError: "",
      designationLevelError: "",
      baseSalaryError: "",
      departmentIdError: "",
      jobTitleIdError: "",
    });
  }, []);

  // Function to initialize form with data
  const initializeFormData = useCallback((data) => {
    setJobFormData(prev => ({
      ...prev,
      ...data,
    }));
  }, []);

  return {
    jobFormData,
    setJobFormData,
    jobFormDataError,
    handleJobChange,
    handleDesignationLevelChange,
    validateStep2,
    designations,
    departments,
    jobTitles,
    resetFormData,
    initializeFormData,
    disableProbationStart,
    disableProbationEnd,
    isExecutive,
  };
}

export default jobInviteService;